<button class="coin-menu-button" [matMenuTriggerFor]="menu" [class.task-item-variable-bg]="!newTask">
  <mat-icon [svgIcon]="(coinTypesMap$ | async)?.[taskCoinTypeControl?.value]?.name || '' | rewardCoinIcon"></mat-icon>
  <mat-icon svgIcon="chevron-down" class="chevron-down"></mat-icon>
</button>
<mat-menu #menu="matMenu" class="oph-select-menu">
  @for (coinType of coinTypes$ | async; track coinType) {
    <button class="oph-select-menu-item" (click)="onCoinType(coinType._id)">
      <mat-icon [svgIcon]="coinType.name | rewardCoinIcon" class="mr-10"></mat-icon>
      {{ coinType.name }}
    </button>
  }
</mat-menu>

<div class="input-container">
  <input
    [formControl]="$any(taskCoinValueControl)"
    [min]="rewardCostMin"
    [max]="rewardCostMax"
    [class.task-item-variable-bg]="!newTask"
    [class.red-border]="taskCoinValueControl.invalid"
    (input)="onRemoveDecimals($any($event.target).value)"
    type="number"
  />

  @if (taskCoinValueControl.invalid) {
    <div class="error-text">{{ rewardCostError }}</div>
  }
</div>
